export const mgPlatformChartIncreaseIcon = {
  data: `<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.31034 13.6897C11.3602 13.6897 13.4138 8.65517 13.4138 5.13793V2.10345M13.4138 2.10345L10.931 4.86207M13.4138 2.10345L15.8966 4.86207M1 1V17H17" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'chart-increase'
}
